var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "col-md-12 col-sm-12 col-lg-8 p-0" },
      [
        _c("pc-product-accordion", {
          attrs: { title: _vm.specification, sectionId: "#specificationsPDP" }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "collapse", attrs: { id: "specificationsPDP" } },
          [
            _c("div", { staticClass: "pt-2" }),
            _vm._v(" "),
            _c("div", { staticClass: "wf-product-specification-groups" }, [
              _c("div", { staticClass: "wf-product-specification-group" }, [
                _c(
                  "div",
                  { staticClass: "wf-product-specification-subgroup" },
                  [
                    _c("dl", { staticClass: "description text-uppercase" }, [
                      _vm.selectedColor.colorNumber
                        ? _c("div", [
                            _c("dt", [
                              _c("div", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$resourceString[
                                        "product.details.specifications.product.swatch"
                                      ]
                                    ) +
                                    "\n                  "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("dd", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.selectedColor.colorName) +
                                  "\n                  " +
                                  _vm._s(_vm.selectedColor.colorNumber) +
                                  "\n                "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedProduct &&
                      _vm.selectedProduct.sellingStyleNumber
                        ? _c("div", [
                            _c("dt", [
                              _c("div", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$resourceString[
                                        "product.details.specifications.product.style"
                                      ]
                                    ) +
                                    "\n                  "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("dd", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.productData.sellingStyleName) +
                                  "\n                  " +
                                  _vm._s(
                                    _vm.selectedProduct.sellingStyleNumber
                                  ) +
                                  "\n                "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.productData.collection
                        ? _c("div", [
                            _c("dt", [
                              _c("div", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$resourceString[
                                        "product.details.specifications.product.collection"
                                      ]
                                    ) +
                                    "\n                  "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("dd", [
                              _c(
                                "a",
                                {
                                  staticClass: "collection-code",
                                  attrs: {
                                    href:
                                      "/product-collection/" +
                                      _vm.productData.collectionCode.code
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.productData.collection) +
                                      "\n                  "
                                  )
                                ]
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.productData.inventorySubType &&
                      _vm.productData.productTypeDesc.toLowerCase() !=
                        _vm.$resourceString[
                          "productCategory.ResinousFlooring"
                        ].toLowerCase()
                        ? _c("div", [
                            _c("dt", [
                              _c("div", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$resourceString[
                                        "product.details.specifications.product.category"
                                      ]
                                    ) +
                                    "\n                  "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("dd", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.productData.inventorySubType) +
                                  "\n                "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.productData.inventoryType
                        ? _c("div", [
                            _c("dt", [
                              _c("div", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$resourceString[
                                        "product.details.specifications.product.type"
                                      ]
                                    ) +
                                    "\n                  "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("dd", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.productData.inventoryType) +
                                  "\n                "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.productData.suggestedAdhesives.length > 0
                        ? _c("div", [
                            _c("dt", [
                              _c("div", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$resourceString[
                                        "product.details.specifications.recommended.adhesive"
                                      ]
                                    ) +
                                    "\n                  "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("dd", { staticClass: "suggested-adhesives" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.productData.suggestedAdhesives
                                      .map(function(c) {
                                        return c.styleName
                                      })
                                      .filter(function(name) {
                                        return name
                                      })
                                      .join(", ")
                                  ) +
                                  "\n                "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.productData.construction
                        ? _c("div", [
                            _c("dt", [
                              _c("div", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$resourceString[
                                        "product.details.specifications.construction"
                                      ]
                                    ) +
                                    "\n                  "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("dd", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.productData.construction) +
                                  "\n                "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.productData.testResults.tarrClassification
                        ? _c("div", [
                            _c("dt", [
                              _c("div", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$resourceString[
                                        "product.details.specifications.wear.rating"
                                      ]
                                    ) +
                                    "\n                  "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("dd", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.productData.testResults
                                      .tarrClassification
                                  ) +
                                  "\n                "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.productData.dyeMethod
                        ? _c("div", [
                            _c("dt", [
                              _c("div", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$resourceString[
                                        "product.details.specifications.dye.method"
                                      ]
                                    ) +
                                    "\n                  "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("dd", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.productData.dyeMethod) +
                                  "\n                "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.productData.fiber
                        ? _c("div", [
                            _c("dt", [
                              _c("div", [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$resourceString[
                                        "product.details.specifications.fiber"
                                      ]
                                    ) +
                                    "\n                  "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("dd", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.productData.fiber) +
                                  "\n                "
                              )
                            ])
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _vm.selectedProduct && _vm.selectedProduct.pdmsLink
                      ? _c("div", [
                          _c(
                            "a",
                            {
                              staticClass:
                                "btn btn-light border-grey spec-pdf-download spec-pdf-download-button mb-4 font-weight-bold",
                              attrs: { href: _vm.selectedProduct.pdmsLink }
                            },
                            [
                              _c("span", {
                                staticClass:
                                  "png-icon png-icon-icons-glyph--k-btn-download mr-3"
                              }),
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$resourceString[
                                      "product.details.specifications.download.specs"
                                    ]
                                  ) +
                                  "\n              "
                              )
                            ]
                          )
                        ])
                      : _vm._e()
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "wf-product-specification-group" }, [
                _vm.productData.productTypeDesc.toLowerCase() !=
                _vm.$resourceString[
                  "productCategory.ResinousFlooring"
                ].toLowerCase()
                  ? _c(
                      "div",
                      { staticClass: "wf-product-specification-subgroup" },
                      [
                        _c(
                          "h3",
                          { staticClass: "label mb-2 font-weight-bold" },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "product.Details.ProductDimensions.Title"
                                  ]
                                ) +
                                "\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "dl",
                          { staticClass: "description text-uppercase" },
                          [
                            _vm.selectedProduct &&
                            _vm.selectedProduct.productSizeImperial
                              ? _c("div", [
                                  _c("dt", [
                                    _c("div", [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.$resourceString[
                                              "product.details.specifications.product.size"
                                            ]
                                          ) +
                                          "\n                  "
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("dd", [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.selectedProduct
                                            .productSizeImperial
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.selectedProduct.productSizeMetric
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("dt", [
                                    _vm.productData.areaPerCarton != null
                                      ? _c("div", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$resourceString[
                                                  "product.Details.AreaBox.Title"
                                                ]
                                              ) +
                                              ":\n                  "
                                          )
                                        ])
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _vm.productData.areaPerCarton != null
                                    ? _c("dd", [
                                        _c("div", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.productData.areaPerCarton
                                                  .imperial.displayValue
                                              ) +
                                              "\n                  "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("div", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.productData.areaPerCarton
                                                  .metric.displayValue
                                              ) +
                                              "\n                  "
                                          )
                                        ])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("dt", [
                                    _vm.productData.gauge != null &&
                                    _vm.productData.gauge.imperial
                                      .formattedValue != "0"
                                      ? _c("div", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$resourceString[
                                                  "product.Details.Gauge.Title"
                                                ]
                                              ) +
                                              ":\n                  "
                                          )
                                        ])
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _vm.productData.gauge != null &&
                                  _vm.productData.gauge.imperial
                                    .formattedValue != "0"
                                    ? _c("dd", [
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.productData.gauge.imperial
                                                .displayValue
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.productData.gauge.metric
                                                .displayValue
                                            )
                                          )
                                        ])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("dt", [
                                    _vm.productData.pileThickness != null &&
                                    _vm.productData.pileThickness.imperial
                                      .formattedValue != "0"
                                      ? _c("div", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$resourceString[
                                                  "product.Details.FinishedPile.Title"
                                                ]
                                              ) +
                                              ":\n                  "
                                          )
                                        ])
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _vm.productData.pileThickness != null &&
                                  _vm.productData.pileThickness.imperial
                                    .formattedValue != "0"
                                    ? _c("dd", [
                                        _c("div", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.productData.pileThickness
                                                  .imperial.displayValue
                                              ) +
                                              "\n                  "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("div", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.productData.pileThickness
                                                  .metric.displayValue
                                              ) +
                                              "\n                  "
                                          )
                                        ])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("dt", [
                                    _vm.productData.totalThickness != null &&
                                    _vm.productData.totalThickness.imperial
                                      .formattedValue != "0"
                                      ? _c("div", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$resourceString[
                                                  "product.Details.TotalThickness.Title"
                                                ]
                                              ) +
                                              ":\n                  "
                                          )
                                        ])
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _vm.productData.totalThickness != null &&
                                  _vm.productData.totalThickness.imperial
                                    .formattedValue != "0"
                                    ? _c("dd", [
                                        _c("div", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.productData.totalThickness
                                                  .imperial.displayValue
                                              ) +
                                              "\n                  "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("div", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.productData.totalThickness
                                                  .metric.displayValue
                                              ) +
                                              "\n                  "
                                          )
                                        ])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("dt", [
                                    _vm.productData.tuftedWeight != null &&
                                    _vm.productData.tuftedWeight.imperial
                                      .formattedValue != "0"
                                      ? _c("div", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$resourceString[
                                                  "product.Details.TuftedYarn.Title"
                                                ]
                                              ) +
                                              ":\n                  "
                                          )
                                        ])
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _vm.productData.tuftedWeight != null &&
                                  _vm.productData.tuftedWeight.imperial
                                    .formattedValue != "0"
                                    ? _c("dd", [
                                        _c("div", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.productData.tuftedWeight
                                                  .imperial.displayValue
                                              ) +
                                              "\n                  "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("div", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.productData.tuftedWeight
                                                  .metric.displayValue
                                              ) +
                                              "\n                  "
                                          )
                                        ])
                                      ])
                                    : _vm._e()
                                ])
                              : _vm._e()
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "wf-product-specification-group" }, [
                _vm.productData.recyclability
                  ? _c(
                      "div",
                      { staticClass: "wf-product-specification-subgroup" },
                      [
                        _c(
                          "h3",
                          { staticClass: "label mb-2 font-weight-bold" },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "product.Details.Backing.Title"
                                  ]
                                ) +
                                "\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "dl",
                          { staticClass: "description text-uppercase" },
                          [
                            _c("div", [
                              _vm.productData.primaryBacking
                                ? _c("div", [
                                    _c("dt", [
                                      _c("div", [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$resourceString[
                                                "product.details.specifications.primary.backing"
                                              ]
                                            ) +
                                            "\n                    "
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("dd", [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.productData.primaryBacking
                                          ) +
                                          "\n                  "
                                      )
                                    ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.productData.secondaryBacking
                                ? _c("div", [
                                    _c("dt", [
                                      _c("div", [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$resourceString[
                                                "product.details.specifications.secondary.backing"
                                              ]
                                            ) +
                                            "\n                    "
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("dd", [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.productData.secondaryBacking
                                          ) +
                                          "\n                  "
                                      )
                                    ])
                                  ])
                                : _vm._e()
                            ])
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.productData.testResults.radiantPanel
                  ? _c(
                      "div",
                      { staticClass: "wf-product-specification-subgroup" },
                      [
                        _c(
                          "h3",
                          { staticClass: "label mb-2 font-weight-bold" },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "product.details.specifications.performance.testing"
                                  ]
                                ) +
                                "\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "dl",
                          { staticClass: "description text-uppercase" },
                          [
                            _c("div", [
                              _c("dt", [
                                _c("div", [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$resourceString[
                                          "product.details.specifications.radiant.panel"
                                        ]
                                      ) +
                                      "\n                  "
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("dd", [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.productData.testResults.radiantPanel
                                    ) +
                                    "\n                "
                                )
                              ])
                            ])
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.productData.warrantyLinks.length &&
                _vm.productData.warrantyLinks[0].link
                  ? _c(
                      "div",
                      { staticClass: "wf-product-specification-subgroup" },
                      [
                        _c(
                          "h3",
                          { staticClass: "label mb-2 font-weight-bold" },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "product.details.specifications.warranty"
                                  ]
                                ) +
                                "\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "dl",
                          { staticClass: "description text-uppercase" },
                          [
                            _vm.productData.warrantyLinks.length
                              ? _c(
                                  "div",
                                  _vm._l(
                                    _vm.productData.warrantyLinks,
                                    function(warrantyLink, index) {
                                      return _c("div", { key: index }, [
                                        _c(
                                          "a",
                                          {
                                            attrs: { href: warrantyLink.link }
                                          },
                                          [_vm._v(_vm._s(warrantyLink.name))]
                                        )
                                      ])
                                    }
                                  ),
                                  0
                                )
                              : _vm._e()
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedColor.customPdqAvailable
                  ? _c("div", [
                      _c("h3", { staticClass: "label mb-2 font-weight-bold" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$resourceString[
                                "product.details.specifications.pdq.details"
                              ]
                            ) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "description text-uppercase",
                        domProps: { innerHTML: _vm._s(_vm.pdqdetails) }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedColor.colorVariationLevel &&
                _vm.selectedColor.colorVariationLevel.code &&
                _vm.productData.inventoryType == "resilient"
                  ? _c(
                      "div",
                      { staticClass: "wf-product-specification-subgroup" },
                      [
                        _c(
                          "dl",
                          { staticClass: "description text-uppercase" },
                          [
                            _c(
                              "div",
                              [
                                _c("pc-product-color-variation", {
                                  attrs: { specification: true }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c("hr")
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-12 col-sm-12 col-lg-8 p-0" },
      [
        _c("pc-product-accordion", {
          attrs: { title: "Sustainability", sectionId: "#sustainabilityPDP" }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pt-3 collapse", attrs: { id: "sustainabilityPDP" } },
          [
            _c("div", { staticClass: "wf-product-specification-groups" }, [
              _c("div", { staticClass: "wf-product-specification-group" }, [
                _c(
                  "div",
                  { staticClass: "wf-product-specification-subgroup" },
                  [
                    _c("dl", { staticClass: "description text-uppercase" }, [
                      _vm.productData.recyclability != null
                        ? _c("dt", [
                            _c("div", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.$resourceString[
                                      "product.details.specifications.recyclability"
                                    ]
                                  ) +
                                  "\n                "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.productData.recyclability != null
                        ? _c("dd", [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.productData.recyclability) +
                                "\n              "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.productData.recycledContent != null &&
                      _vm.productData.recycledContent.postConsumer != null &&
                      _vm.productData.recycledContent.postIndustrial != null &&
                      _vm.productData.recycledContent.total != null
                        ? _c("dt", [
                            _c("div", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.$resourceString[
                                      "product.Details.TotalRecyled.Title"
                                    ]
                                  ) +
                                  ":\n                "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.productData.recycledContent != null &&
                      _vm.productData.recycledContent.postConsumer != null &&
                      _vm.productData.recycledContent.postIndustrial != null &&
                      _vm.productData.recycledContent.total != null
                        ? _c("dd", [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "product.Details.PostConsumer.Label"
                                  ]
                                ) +
                                ":\n                " +
                                _vm._s(
                                  _vm.productData.recycledContent.postConsumer
                                ) +
                                " "
                            ),
                            _c("br"),
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "product.Details.PostIndustrial.Label"
                                  ]
                                ) +
                                ":\n                " +
                                _vm._s(
                                  _vm.productData.recycledContent.postIndustrial
                                ) +
                                " "
                            ),
                            _c("br"),
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "product.Details.Total.Label"
                                  ]
                                ) +
                                ":\n                " +
                                _vm._s(_vm.productData.recycledContent.total) +
                                "\n              "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("dt", [
                        _vm.productData.carbonData.embodiedCarbon != null
                          ? _c("div", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.$resourceString[
                                      "product.Details.EmbodiedCarbon.Title"
                                    ]
                                  ) +
                                  ":\n                "
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _vm.productData.carbonData.embodiedCarbon != null
                        ? _c("dd", [
                            _c("div", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.productData.carbonData.embodiedCarbon
                                      .displayValue
                                  ) +
                                  "\n                "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("dt", [
                        _vm.productData.countryOfOrigin != null
                          ? _c("div", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.$resourceString[
                                      "product.Details.CountryOfOrigin.Title"
                                    ]
                                  ) +
                                  ":\n                "
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _vm.productData.countryOfOrigin != null
                        ? _c("dd", [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.productData.countryOfOrigin) +
                                "\n              "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "wf-product-specification-group" }, [
                _c(
                  "div",
                  { staticClass: "wf-product-specification-subgroup" },
                  [
                    _vm.productData.attributes.length !== 0 ||
                    _vm.productData.certifications.length !== 0
                      ? _c(
                          "h3",
                          { staticClass: "label mb-2 font-weight-bold" },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "product.details.specifications.third.party.certificates"
                                  ]
                                ) +
                                "\n            "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "dl",
                        { staticClass: "description text-uppercase" },
                        [
                          _vm._l(_vm.productData.attributes, function(
                            attribute
                          ) {
                            return _vm.productData.attributes.length > 0
                              ? _c("div", { key: attribute.name }, [
                                  _c("dt", [
                                    attribute.pdfLink
                                      ? _c("div", [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: attribute.pdfLink,
                                                target: "_blank"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(attribute.name) +
                                                  "\n                      "
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c("dd", { staticClass: "pdfLink" }, [
                                    attribute.pdfLink
                                      ? _c("div", [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(attribute.status) +
                                              "\n                    "
                                          )
                                        ])
                                      : _vm._e()
                                  ])
                                ])
                              : _vm._e()
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.productData.certifications, function(
                            certification
                          ) {
                            return _vm.productData.certifications.length > 0
                              ? _c("div", { key: certification.name }, [
                                  _c("dt", [
                                    certification.pdfLink
                                      ? _c("div", [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: certification.pdfLink,
                                                target: "_blank"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(certification.name) +
                                                  "\n                      "
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c("dd", { staticClass: "pdfLink" }, [
                                    certification.pdfLink
                                      ? _c("div", [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(certification.status) +
                                              "\n                    "
                                          )
                                        ])
                                      : _vm._e()
                                  ])
                                ])
                              : _vm._e()
                          })
                        ],
                        2
                      )
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "wf-product-specification-group" })
            ])
          ]
        ),
        _vm._v(" "),
        _c("hr")
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }